import { render } from "./TopicTable.vue?vue&type=template&id=cb6c084c"
import script from "./TopicTable.vue?vue&type=script&lang=js"
export * from "./TopicTable.vue?vue&type=script&lang=js"

import "./TopicTable.vue?vue&type=style&index=0&id=cb6c084c&lang=css"

import exportComponent from "C:\\yasukochi\\Work\\11_Marron\\00_Working\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__